import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

const HOME_PATH = '/home/';

const NEWS_PATH = `${HOME_PATH}news`;

export const homeRoutesConfig = createRouteConfig(
  {
    home: {
      path: HOME_PATH,
      generatePath: () => HOME_PATH,
    },
    news: {
      path: NEWS_PATH,
      generatePath: () => NEWS_PATH,
    },
  },
  HOME_PATH,
);
